import { type FC } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { type FormValues } from "@userFrontend/features/promotion/components/Assessment/schema";
import { Presentation } from "./Presentation";

export const AvgMonthlyRequestedCustomersField: FC = () => {
  const {
    setValue,
    control,
    formState: { errors },
  } = useFormContext<FormValues>();

  const value = useWatch({ control, name: "monthlyNominatedCustomers" });
  const errorMessage = errors.monthlyNominatedCustomers?.message;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue("monthlyNominatedCustomers", e.target.value);
  };

  return <Presentation value={value} onChange={handleChange} errorMessage={errorMessage} />;
};
